import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import EventCharts, { EventCharts as EventChartsInnerComponent } from '@components/machines/components/eventsChart';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { connect } from 'react-redux';
import { getNCFileById } from '@reducers/manufacture';
import { getToolById } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { useToolDetails } from '@v2/pages/common/hooks/useToolsDetails';

interface ToolsDetailsNCFilePerformanceProductiveProps {}

const ToolsDetailsNCFilePerformanceProductiveComponent: FC<ToolsDetailsNCFilePerformanceProductiveProps> = ({
  getToolById,
  updateHeaderConfig,
  getNCFileById,
}) => {
  const title = useTitle();

  useToolDetails({
    getToolById,
    updateHeaderConfig,
    getNCFileById,
    getFullNCFile: true,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <EventCharts getContentElement={(props) => <EventChartsInnerComponent {...props} />} />
    </DetailsPageWrapper>
  );
};

const ToolsDetailsNCFilePerformanceProductive = connect(({}) => ({}), {
  getToolById,
  updateHeaderConfig,
  getNCFileById,
})(ToolsDetailsNCFilePerformanceProductiveComponent);

export { ToolsDetailsNCFilePerformanceProductive };
